var _excluded = ["onChange", "isChecked", "size", "hasError", "hasExpandedClickField", "name"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import { cover, rgba } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import { lowEmphasisOpacity } from "../../../settings";
import { KeyboardEventKeys } from "../../../typings/types";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
export var defaultProps = {
  size: "default"
};
export var sizeSpaces = {
  "default": 2,
  big: 3
};
var StyledInput = styled.input.withConfig({
  componentId: "sc-1asp5g6-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    $size = _ref.$size,
    $hasError = _ref.$hasError,
    $hasExpandedClickField = _ref.$hasExpandedClickField,
    theme = _ref.theme;
  return css(["display:inline-flex;flex-shrink:0;align-items:center;justify-content:center;width:", ";height:", ";margin:0;border:", " solid ", ";appearance:none;border-radius:", ";cursor:pointer;&:hover{border-color:", ";}&:checked{border-color:", ";&::after{content:\"\";display:block;width:", ";height:", ";border-radius:", ";background-color:", ";}}", " ", ""], space(sizeSpaces[$size]), space(sizeSpaces[$size]), unit(1), getBorderColor(theme, $onColor, "high"), getBorderRadius(theme, "huge"), getBorderColor(theme, $onColor, "high", "hover"), getColor(theme, "success"), space(sizeSpaces[$size] / 2), space(sizeSpaces[$size] / 2), getBorderRadius(theme, "large"), getColor(theme, "success"), $hasError && css(["border-color:", ";"], rgba(getColor(theme, "error"), lowEmphasisOpacity)), $hasExpandedClickField && css(["&::before{", ";content:\"\";}"], cover()));
});
function RadioButtonAtm(_ref2) {
  var onChange = _ref2.onChange,
    isChecked = _ref2.isChecked,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? defaultProps.size : _ref2$size,
    hasError = _ref2.hasError,
    hasExpandedClickField = _ref2.hasExpandedClickField,
    name = _ref2.name,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KeyboardEventKeys.ENTER || event.key === KeyboardEventKeys.SPACE) {
      event.preventDefault();
      onChange(event);
    }
  };
  return /*#__PURE__*/React.createElement(StyledInput, _extends({
    type: "radio",
    name: name,
    checked: isChecked,
    onChange: onChange,
    onKeyDown: handleKeyDown,
    $hasError: hasError,
    $hasExpandedClickField: !!hasExpandedClickField,
    $size: size,
    $onColor: onColor,
    autoComplete: "off",
    tabIndex: 0
  }, restProps));
}
export default RadioButtonAtm;